import { render, staticRenderFns } from "./RealizarVenta.vue?vue&type=template&id=1b47ddbc&scoped=true&"
import script from "./RealizarVenta.vue?vue&type=script&lang=js&"
export * from "./RealizarVenta.vue?vue&type=script&lang=js&"
import style0 from "./RealizarVenta.vue?vue&type=style&index=0&id=1b47ddbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47ddbc",
  null
  
)

export default component.exports